import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M11.802 4.348c.13-.024.265-.024.396 0 .152.029.29.098.384.146l.026.013 9.16 4.58a.6.6 0 0 1 0 1.074l-3.677 1.838 3.677 1.838a.6.6 0 0 1 0 1.074l-9.16 4.58-.026.013a1.454 1.454 0 0 1-.384.145 1.074 1.074 0 0 1-.396 0 1.454 1.454 0 0 1-.384-.145l-.026-.013-9.16-4.58a.6.6 0 0 1 0-1.074L5.908 12l-3.676-1.84a.6.6 0 0 1 0-1.074l9.16-4.58.026-.013c.094-.048.231-.117.384-.146Zm-4.278 7.117a.527.527 0 0 0-.011-.005L3.842 9.624l8.086-4.043.072-.036.072.036 8.086 4.043-3.671 1.836a.634.634 0 0 0-.012.005l-4.404 2.202-.071.036-.072-.036-4.404-2.202ZM7.25 12.67l-3.408 1.704 8.086 4.043.072.036.072-.036 8.086-4.043-3.408-1.704-4.142 2.07-.026.014a1.454 1.454 0 0 1-.384.145 1.074 1.074 0 0 1-.396 0 1.454 1.454 0 0 1-.384-.145l-.026-.013L7.25 12.67Z"
      clip-rule="evenodd"
    />
  </svg>
`;
